import IconButton from "../../common/view/IconButton";
import styles from "../css/CollectionListItemView.module.css";
import Collection from "../model/Collection";
import { ReactComponent as CollectionIcon } from "../../../img/iconImgAllCollectionFill.svg";
import { ReactComponent as MoreIcon } from "../../../img/iconImgAllMore.svg";
import classNames from "classnames";
import { IconColor } from "../../common/model/IconColor";

interface CollectionListItemViewProps {
  position: CollectionItemViewPosition;
  collection: Collection;
  onSelectCollection: () => void;
  onClickMoreButton: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export default function CollectionListItemView(
  props: CollectionListItemViewProps
) {
  const iconColor = IconColor.from(props.collection.color);

  return (
    <>
      <div
        className={classNames(styles.container, styles[props.position])}
        onClick={props.onSelectCollection}
      >
        <div className={styles.leftContainer}>
          <IconButton
            showing={true}
            icon={CollectionIcon}
            color={iconColor.color}
            onClick={() => {}}
            hideHoverAnimation={true}
          />
          <span className={styles.titleText}>{props.collection.title}</span>
        </div>
        <div className={styles.rightContainer}>
          <span className={styles.groupCountText}>
            {props.collection.groupCount}
          </span>
          <IconButton
            showing={!props.collection.isDefaultCollection}
            icon={MoreIcon}
            onClick={(e) => {
              e.stopPropagation();
              props.onClickMoreButton(e);
            }}
          />
          <IconButton
            showing={props.collection.isDefaultCollection}
            icon={MoreIcon}
            onClick={() => {}}
            opacity={0}
            hideHoverAnimation={true}
          />
        </div>
      </div>
    </>
  );
}

export enum CollectionItemViewPosition {
  top = "top",
  center = "center",
  bottom = "bottom",
  normal = "normal",
}

export function getCollectionItemViewPositionUsingIndex(
  index: number,
  collections: Collection[]
): CollectionItemViewPosition {
  const count = collections.length;

  if (count <= 0 || index < 0 || index >= count) {
    throw new Error("Invalid index or empty collection");
  }

  if (count === 1) {
    return CollectionItemViewPosition.normal;
  }

  if (index === 0) {
    return CollectionItemViewPosition.top;
  }

  if (index === count - 1) {
    return CollectionItemViewPosition.bottom;
  }

  return CollectionItemViewPosition.center;
}
